var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "companion-login-form form-group",
      attrs: { autocomplete: "on" },
    },
    [
      _c(
        "div",
        { staticClass: "mx-12" },
        [
          _c("base-input", {
            staticClass: "companion-login-input",
            attrs: {
              label: _vm.$t("LoginPage.loginLabel"),
              placeholder: _vm.$t("LoginPage.loginPlaceholder"),
              "any-error": _vm.loginErrors.length > 0,
            },
            on: {
              animationstart: _vm.loginAnimationStart,
              focusout: _vm.updateLoginInputErrors,
              input: _vm.resetLoginInputErrors,
            },
            model: {
              value: _vm.$v.login.$model,
              callback: function ($$v) {
                _vm.$set(_vm.$v.login, "$model", $$v)
              },
              expression: "$v.login.$model",
            },
          }),
          _c("input-error", { attrs: { errors: _vm.loginErrors } }),
          _c("password-input", {
            staticClass: "companion-password-input",
            attrs: {
              label: _vm.$t("LoginPage.password"),
              placeholder: _vm.$t("LoginPage.passwordPlaceholder"),
            },
            on: { animationstart: _vm.passwordAnimationStart },
            model: {
              value: _vm.$v.password.$model,
              callback: function ($$v) {
                _vm.$set(_vm.$v.password, "$model", $$v)
              },
              expression: "$v.password.$model",
            },
          }),
          _c(
            "base-checkbox",
            {
              attrs: {
                "check-box-classes": "border-gray-300",
                value: _vm.stayLoggedIn,
                disabled: !_vm.cookiesAccepted,
              },
              on: { change: _vm.onChangeStayLoggedIn },
            },
            [
              _c("span", { staticClass: "form-input-label" }, [
                _vm._v(" " + _vm._s(_vm.$t("LoginPage.keepMeLoggedIn")) + " "),
              ]),
              _c("svg-icon", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.keepMeLoggedInTooltip,
                    expression: "keepMeLoggedInTooltip",
                  },
                ],
                staticClass: "icon-sm text-gray-500 ms-2",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _c(
            "base-button",
            {
              staticClass: "mx-16 mt-6 flex items-center justify-center",
              attrs: { isButtonType: false },
            },
            [
              _c("input", {
                staticClass:
                  "btn btn-primary text-white bg-blue-500 h-full w-full",
                attrs: { type: "submit", disabled: _vm.isLoginButtonDisabled },
                domProps: { value: _vm.$t("LoginPage.loginButton") },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.doLogin.apply(null, arguments)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }